package org.vreo.devicehub.features.device.presentation.components

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.material3.Card
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.stringResource

import org.vreo.devicehub.features.core.domain.device.device.AnprDevice
import org.vreo.devicehub.features.core.domain.device.device.ProductType

import devicehub.composeapp.generated.resources.Res
import devicehub.composeapp.generated.resources.device_details_connection_string_label
import devicehub.composeapp.generated.resources.device_details_linking_password
import devicehub.composeapp.generated.resources.device_details_model_label
import devicehub.composeapp.generated.resources.device_details_serial_number_label
import devicehub.composeapp.generated.resources.device_details_tag_label
import devicehub.composeapp.generated.resources.device_details_type_label

/**
 * Device details composable
 *
 * @param device device to present
 * @param modifier composable modifier
 */
@Composable
fun DeviceDetails(
    device: AnprDevice,
    modifier: Modifier = Modifier,
) {
    Card(
        modifier = modifier
    ) {
        SelectionContainer {
            Column(
                horizontalAlignment = Alignment.Start,
                verticalArrangement = Arrangement.spacedBy(8.dp),
                modifier = Modifier
                    .padding(16.dp)
                    .fillMaxHeight()
            ) {
                Text(
                    text = "Device ID: ${device.deviceId}",
                    style = MaterialTheme.typography.displaySmall
                )

                HorizontalDivider(modifier = Modifier.padding(8.dp))

                DeviceText(
                    label = stringResource(Res.string.device_details_type_label),
                    content = device.device.deviceType
                )

                DeviceText(
                    label = stringResource(Res.string.device_details_model_label),
                    content = device.device.model
                )

                DeviceText(
                    label = stringResource(Res.string.device_details_serial_number_label),
                    content = device.serialNumber
                )

                DeviceText(
                    label = stringResource(Res.string.device_details_tag_label),
                    content = device.userTag ?: ""
                )

                DeviceText(
                    label = stringResource(Res.string.device_details_linking_password),
                    content = device.linkinPassword ?: ""
                )

                DeviceText(
                    label = stringResource(Res.string.device_details_connection_string_label),
                    content = device.primaryConnectionKey ?: ""
                )
            }
        }
    }
}

/**
 * Device text composable for displaying details
 *
 * @param label
 * @param content
 */
@Composable
private fun DeviceText(
    label: String,
    content: String
) {
    Row(
        horizontalArrangement = Arrangement.spacedBy(8.dp)
    ) {
        Text("$label:")
        Text(content)
    }
}

@Preview
@Composable
fun DeviceDetailsPreview() {
    MaterialTheme {
        DeviceDetails(
            device = AnprDevice(
                deviceId = "volt-s1-pole-short-range-0001",
                device = ProductType.VoltS1PoleShortRange,
                serialNumber = "0001",
                softwareVersion = "1.2.3",
                ocrVersion = "1.2.3",
                localIpAddress = "192.168.1.1",
                macAddress = "111:222:333",
                active = true,
                primaryConnectionKey = "123456789"
            ),
            modifier = Modifier
                .widthIn(400.dp)
        )
    }
}
